var ProductJsNew = function( item, product, isQuickView ) {
  var optionsMap = {};
  var optionsMapAll = {};
  var productJs = this;
  var stickyATC = $('#stickyATC');
  var mobileStickyAtc = $('#mobile-sticky-atc');

	var productOptions = product.options.map(function(e){return e.toLowerCase()});
  var productGallerySwiper;
  var quickViewSwiper;
  var variantTextReplacementMetafield = document.querySelector('.main-product__item').getAttribute('data-words-to-be-removed-from-variant-title') ? document.querySelector('.main-product__item').getAttribute('data-words-to-be-removed-from-variant-title').split(",") : undefined;
  var variantAlreadySelected = false;
  var initSwiper = false;
  var initZoomSwiper = false;


  productJs.config = {
    gallery:{
      galleryGroupByOptions: 'fabric color, top color, seat color, frame color, desk color, leg color, chair color, stand color, cord color, color, orientation, seat, drawer size, power, panel type, desk size, accessories color, chair/headrest color, style, base color, configuration, height, back, sleeve size, stand size, tray size, color & material, cabinet drawers'.split(',').map(function(s) { return s.trim() }).filter(function(v){return v!=='' && productOptions.indexOf(v)>-1}),
      galleryGroupMatchMode: '4' //1 Match Everything, 2 Match Any, 4 Exclusive OR  
    }
  };

  var init = function() {
    if(!item.hasClass('initialized')) {
      
      item.data('productjs', productJs);
      initVariantStatus();
      initializeVariantSelector();

      item.addClass('initialized');
      window.Branch.product.formatSwatches();
      window.Branch.product.resizeSwatchesHeader(`.main-product`);
      window.Branch.product.customSwatchContainerResize(`.main-product`);
      window.Branch.product.initAccordion();

      window.Branch.product.initSwatchClickListener(product, isQuickView, 'product');
      let containerSelector = `.main-product .main-product__item#main-product-item-${product.id}`;

      if(isQuickView) {
        let mainProductHideSingle = document.querySelector('.main-product[data-quick-view="false"] .swatches-container') && document.querySelector('.main-product[data-quick-view="false"] .swatches-container').getAttribute('data-hide-single-option-size-swatches') == 'true' ? true : false;
        if(mainProductHideSingle){
          document.querySelector('.main-product[data-quick-view="true"] .swatches-container').setAttribute('data-hide-single-option-size-swatches', true)
        }
        
        setTimeout(() => {
          window.Branch.product.formatPreOrderSwatch(product.id);
        }, 1000)
      }
    }
  };

  var initVariantStatus = function() {
    $.each(product.variants, function(key, variant){
      //AVAILABLE
      if(variant.available) {
        variant.status = 'available';
      } else {
        //SOLDOUT
        variant.status = 'soldout';
      }
    });
  };

    

    productJs.filterThumbs = function(objectOptions, optionsContainer, gallery, allow_image_filtering_by_size) {
      //Example reference:
      //objectOptions: product.options
      //optionsContainer: variant;
      //gallery: jQuery object of the gallery, ex. $('.thumbs'), $('.main-product-gallery__inner-container'), etc.

      var galleryOptions = productJs.config.gallery;
      var groupOptionProperties = [];

      if(allow_image_filtering_by_size){
        galleryOptions.galleryGroupByOptions.push('size');
      }

      $(galleryOptions.galleryGroupByOptions).each(function (ix, e){
        $(objectOptions).each(function(ix2,e2){
          if (Simplistic.handleize(e) == Simplistic.handleize(e2))
            groupOptionProperties.push('option'+(1+ix2))
        })
      })
      
      if(groupOptionProperties.length>0) {
        gallery.find('.slideVisible').addClass('visibility-transition').removeClass('slideVisible');

        var slideSelector = '';
        // var nextVariantSlideSelector = '';

        let addonsVariants = document.querySelector('.main-product .addons-variants #addon-products-for-atc') && document.querySelector('.main-product .addons-variants #addon-products-for-atc').getAttribute('value') ? JSON.parse(document.querySelector('.main-product .addons-variants #addon-products-for-atc').getAttribute('value')) : [];
        const nonSelectedAddOnOptions = [...document.querySelectorAll('.main-product .addons-variants .item.disabled')].map(item => item.getAttribute('data-addon-handle'));

        const updateSelectorForAddonOnSpecificImages = function(selector, addonsVariants, nonSelectedAddOnOptions){
          let newSelector = `${selector}`;
          if(addonsVariants.length == 0){
            newSelector = `${newSelector}:not([data-included-addon-handle])`;
          } else {
            addonsVariants.forEach((addonsVariant) => {
              newSelector = `${newSelector}:not([data-excluded-addon-handle="_${addonsVariant.productHandle}_"])`;
            });
            nonSelectedAddOnOptions.forEach((nonSelectedAddOn) => {
              newSelector = `${newSelector}:not([data-included-addon-handle="_${nonSelectedAddOn}_"])`;
            })
          }
          return newSelector;
        }

        $(groupOptionProperties).each(function(ix,e){
          var part1Selector = '';
          var part2Selector = '';

          // var nextVariantPart1Selector = '';
          // var nextVariantPart2Selector = '';

          if(slideSelector=='' || galleryOptions.galleryGroupMatchMode>=2)
            part1Selector += ' .main-product-gallery__item';
          // nextVariantPart1Selector += ' .main-product-gallery__item';

          // console.log('ix', ix, 'e', e);
          // console.log('objectOptions', objectOptions);



          part1Selector += '[data-'+Simplistic.handleize(galleryOptions.galleryGroupByOptions[ix])+'*="_'+Simplistic.handleize(optionsContainer[e])+'_"]';
        //  console.log('galleryOptions.galleryGroupByOptions', galleryOptions.galleryGroupByOptions)
        //  console.log('optionsContainer', optionsContainer)
        //  nextVariantPart1Selector += '[data-'+Simplistic.handleize(galleryOptions.galleryGroupByOptions[ix])+'*="_'+Simplistic.handleize(optionsContainer[e])+'_"]';
          if (galleryOptions.galleryGroupMatchMode==4) {
            part2Selector = ', ' +part1Selector;
            // nextVariantPart2Selector = ', ' +nextVariantPart1Selector;
            $(groupOptionProperties).each(function(ix2,e2){
              if (e2!=e) {
                part1Selector += ':not([data-'+Simplistic.handleize(galleryOptions.galleryGroupByOptions[ix2])+'])';
                part2Selector += '[data-'+Simplistic.handleize(galleryOptions.galleryGroupByOptions[ix2])+'*="_'+Simplistic.handleize(optionsContainer[e2])+'_"]';

                // nextVariantPart1Selector += ':not([data-'+Simplistic.handleize(galleryOptions.galleryGroupByOptions[ix2])+'])';
                // nextVariantPart2Selector += '[data-'+Simplistic.handleize(galleryOptions.galleryGroupByOptions[ix2])+'*="_'+Simplistic.handleize(optionsContainer[e2])+'_"]';


              }
            });
          }

          part1Selector = updateSelectorForAddonOnSpecificImages(part1Selector, addonsVariants, nonSelectedAddOnOptions)
          part2Selector = updateSelectorForAddonOnSpecificImages(part2Selector, addonsVariants, nonSelectedAddOnOptions)

          // console.log('slideSelector', slideSelector)

          slideSelector += (slideSelector=='' || galleryOptions.galleryGroupMatchMode==1 ? '' : ', ') + part1Selector + part2Selector;
            // nextVariantSlideSelector += (nextVariantSlideSelector=='' || galleryOptions.galleryGroupMatchMode==1 ? '' : ', ') + nextVariantPart1Selector + nextVariantPart2Selector;
        });

        //Show the images that don't have any of the galleryGroupByOptions
        var withoutAltSelector = ' .main-product-gallery__item';
        $(galleryOptions.galleryGroupByOptions).each(function(){
          withoutAltSelector += ':not([data-'+Simplistic.handleize(this)+'])';
          withoutAltSelector =  updateSelectorForAddonOnSpecificImages(withoutAltSelector, addonsVariants, nonSelectedAddOnOptions)
        });
        slideSelector += ', ' + withoutAltSelector;
        // nextVariantSlideSelector += ', ' + withoutAltSelector;

        var sortCompare = function(a,b){
            akey = parseInt($(a).attr("data-index"));
            bkey = parseInt($(b).attr("data-index"));
            if (akey == bkey) return 0;
            if (akey < bkey) return -1;
            if (akey > bkey) return 1;
        };


        gallery.find(slideSelector).sortDomElements(sortCompare).addClass('slideVisible');

        // Partial matching: find items where all their specified attributes match the variant
        gallery.find('.main-product-gallery__item:not(.slideVisible)').each(function(){
          var $item = $(this);
          var allAttributesMatch = true;
          var hasAnyAttribute = false;

          // Build variant option values for comparison
          var variantOptions = {};
          $(groupOptionProperties).each(function(ix, e){
            var optionName = Simplistic.handleize(galleryOptions.galleryGroupByOptions[ix]);
            var optionValue = '_' + Simplistic.handleize(optionsContainer[e]) + '_';
            variantOptions[optionName] = optionValue;
          });

          // Check each groupByOption to see if item has it and if it matches
          for (var i = 0; i < galleryOptions.galleryGroupByOptions.length; i++) {
            var optionName = Simplistic.handleize(galleryOptions.galleryGroupByOptions[i]);
            var itemValue = $item.attr('data-' + optionName);

            if (itemValue) {
              hasAnyAttribute = true;
              if (itemValue !== variantOptions[optionName]) {
                allAttributesMatch = false;
                break;
              }
            }
          }

          // If item has at least one attribute and all match, show it
          if (hasAnyAttribute && allAttributesMatch) {
            // Check addon filtering
            var passesAddonFilter = true;
            if (addonsVariants.length == 0) {
              if ($item.attr('data-included-addon-handle')) {
                passesAddonFilter = false;
              }
            } else {
              for (var j = 0; j < addonsVariants.length; j++) {
                if ($item.attr('data-excluded-addon-handle') === '_' + addonsVariants[j].productHandle + '_') {
                  passesAddonFilter = false;
                  break;
                }
              }
              for (var k = 0; k < nonSelectedAddOnOptions.length; k++) {
                if ($item.attr('data-included-addon-handle') === '_' + nonSelectedAddOnOptions[k] + '_') {
                  passesAddonFilter = false;
                  break;
                }
              }
            }

            if (passesAddonFilter) {
              $item.addClass('slideVisible');
            }
          }
        });

        gallery.find('.slideVisible').sortDomElements(sortCompare);
        gallery.find('.visibility-transition').removeClass('visibility-transition');
      }else{
        gallery.find('.main-product-gallery__item').addClass('slideVisible');
      }
      
      if(gallery.parent().hasClass('swiper-initialized')) {
        // if(gallery.closest('.main-product__item').attr('data-quick-view') == "false"){
        //   productGallerySwiper.slideTo(0);
        // } else {
        //   quickViewSwiper.slideTo(0)
        // }
      } else {
        gallery.find('.slideVisible').each(function(key, object){
          $(this).removeClass('whole half');
          if(gallery.find('.slideVisible').size() <=3 || $(this).hasClass('is-video')){
            $(this).addClass('whole');
          }else{
            
            if(key%3 == 0){
              $(this).addClass('whole');
            }else{
              $(this).addClass('half');
            }
          }
        });
        if(gallery.find('.slideVisible:last').hasClass('half') && gallery.find('.slideVisible:last').prevAll('.slideVisible:first').hasClass('whole')){
           gallery.find('.slideVisible:last').removeClass('half').addClass('whole');
        }
      }
      let quickViewAddonGallery = document.querySelector(`.main-product .main-product__item[data-quick-view="true"] .main-product-gallery[data-product-id="${product.id}"]`)
      if(quickViewAddonGallery && quickViewAddonGallery.getAttribute('data-initial-variant-selected') !== 'true'){
        setTimeout(function(){
          quickViewAddonGallery.setAttribute('data-initial-variant-selected', true);
        }, 500)
    }
    }

    var initializeVariantSelector = function() {
      var variantSelectorId = "product-select-"+product.id;
      var selectCallback = onVariantSelected();


      new Shopify.OptionSelectors(variantSelectorId, { product: product, onVariantSelected: selectCallback });

      if(product.options.length > 1) {
        if(product.variants.length > 1) {
          linkOptionSelectors(product);
        }

        // Add label if only one product option and it isn't 'Title'.
        if(product.options.length == 1 && product.options[0] != 'Title') {
          item.find('.selector-wrapper:eq(0)').prepend('<label>'+product.options[0]+'</label>');
        }

        item.find('.selector-wrapper label').append(':');
      } else {
        if(product.variants.length > 1) {
          item.find('.select-variant').change(function(){
            var variantSelected = false;
            $.each(product.variants, function(key, variant){
              if(variant.id==item.find('.select-variant').val()) {
                variantSelected = variant;
                return;
              }
            });
            selectCallback(variantSelected, null);
          });
        }
      }

        item.find('.swatch :radio').change(function() {
          var optionIndex = $(this).closest('.swatch').attr('data-option-index');
          var optionValue = $(this).val();
          $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
        });
        stickyATC.find('.swatch :radio').change(function() {
          var optionIndex = $(this).closest('.swatch').attr('data-option-index');
          var optionValue = $(this).val();
          
          item.find('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
        });
        mobileStickyAtc.find('.swatch-dropdown__sliding-option-selector-outer-container :radio').change(function() {
          var optionIndex = $(this).closest('.swatch-dropdown__sliding-option-selector-outer-container').attr('data-option-index');
          var optionValue = $(this).val();

          item.find('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
        });

      if(product.variants.length==1) {
        selectCallback(product.variants[0], null);
      } else {
          if(document.querySelector('body').classList.contains('template-page-bundles') == false){
            productJs.setVariant(productJs.getFirstAvailableVariant());
          }
          
          /* Make sure selected or first available variant is selected on-load */

          let selectedOrFirstAvailableVariantId = parseInt(document.querySelector(`.swatches-container[data-product-id="${product.id}"]`).getAttribute('data-first-available-or-selected-variant-id'));    
          let selectedOrFirstAvailableVariant = product.variants.find(variant => variant.id === selectedOrFirstAvailableVariantId);
          let singleOptionSelectors = document.querySelectorAll(`#main-product-item-${product.id} .single-option-selector`);
          let updatedSelectedVariant = false;

          singleOptionSelectors.forEach((singleOptionSelector, index) => {
            if(singleOptionSelector.value != selectedOrFirstAvailableVariant.options[index]){
              
              updatedSelectedVariant = true;
            }
          });
          
          if(updatedSelectedVariant == true){
            singleOptionSelectors.forEach((singleOptionSelector, index) => {
              singleOptionSelector.value = selectedOrFirstAvailableVariant.options[index];
              singleOptionSelector.dispatchEvent(new Event('change', { bubbles: true }));
            });
          }

        
      }
    };

    productJs.getFirstAvailableVariant = function() {
      let noAvailableVariants = true
      for(var i=0; i < product.variants.length; i++){ 
        if(product.variants[i].available)
        noAvailableVariants = false;
          return product.variants[i];
      }    
      if(noAvailableVariants == true){
        return product.variants[0];
      }
    };
  
    productJs.getVariantBySku = function(sku) {
      for(var i=0; i < product.variants.length; i++){ 
        if(product.variants[i].sku == sku)
          return product.variants[i];
      }    
    };

    productJs.getVariantById = function(id) {
      for(var i=0; i < product.variants.length; i++){ 
        if(product.variants[i].id == id) {
          return product.variants[i];
        }
      }
    };

    productJs.getCurrentVariant = function() {
      var variantId = item.find('[name="id[]"]').val();
        if(variantId!="") {
          return productJs.getVariantById(variantId);
        } else {
          return false;
        }
    };

    // productJs.getNextVariant = function() {
    //   var currentVariantId = item.find('[name="id[]"]').val();
    //   var nextVariantId;
    //     if(currentVariantId!="") {
    //       let variantIdsOrder = JSON.parse(document.querySelector(`#variant_ids_in_order--${product.id}`).innerHTML);
    //       console.log('variantIdsOrder', variantIdsOrder)
    //       // return productJs.getVariantById(nextVariantId);
    //     } else {
    //       return false;
    //     }
    // };

    window.Branch = window.Branch || {};
    window.Branch.product = window.Branch.product || {};

    window.Branch.product.getOriginalPrice = function(currentVariant, discount_code_amount){
      var originalPriceAmount = null;
      if(currentVariant.compare_at_price != null){
        if(currentVariant.compare_at_price > currentVariant.price) {
          var originalPriceAmount = currentVariant.compare_at_price;
        } else if (discount_code_amount > 0) {
          var originalPriceAmount = currentVariant.price;
        } 
      } else {
        if (discount_code_amount > 0) {
          var originalPriceAmount = currentVariant.price;
        } 
      }

      return originalPriceAmount;
    }

    window.Branch.product.getCurrentPrice = function(currentVariant, discount_code_amount){
      if (discount_code_amount > 0) {
        var currentPriceAmount =  Math.floor(((100.0 - discount_code_amount) * currentVariant.price) / 100.0);
      } else {
        var currentPriceAmount = currentVariant.price;
      }
      return currentPriceAmount;
    }

    productJs.getDiscountAmountMessage = function(){
      var discount_code_amount = 0;
      var discount_code_message = '';
        
        

        

        

        let discountObject = {'discount_code_amount': discount_code_amount, 'discount_code_message': discount_code_message}

        return discountObject;
    }

      productJs.updateDiscountCodePrice = function(variant, product, variantSwatchValue) {
        let priceData =  document.querySelector(`.per-variant-pricing[data-product-handle="${product.handle}"]`) ? JSON.parse(document.querySelector(`.per-variant-pricing[data-product-handle="${product.handle}"]`).innerText)[`${variant.id}`] : {};
        
        // console.log('priceData', priceData)

        // console.log('priceData', priceData, variant, product);
        if(priceData['cpx']){
          let originalPrice = 0;
          let currentPrice = 0;
          let discountMessage = "";
          let discountAmount = 0;



          if(priceData['constituents']){
            let bundleDiscountAmount = 5;
            if(product['handle'] == "cable-organizer" || product['handle'] == "open-box-cable-organizer" || product['handle'] == "artisan-drawer"){bundleDiscountAmount = 0};
            priceData['constituents'].forEach((constituent) => {
              let codeDiscountData = window.Branch.functions.returnDiscountCodeUpdates(parseInt(constituent.price) * parseInt(constituent.quantity), parseInt(constituent.compare_at_price) * parseInt(constituent.quantity), 0, '', constituent.handle);
              let codeDiscountAmountPercentage = codeDiscountData['discountAmount'] > 0 ? ((codeDiscountData.originalPrice - codeDiscountData.currentPrice) / codeDiscountData.originalPrice) * 100 + bundleDiscountAmount : 0 + bundleDiscountAmount;
              
              originalPrice = originalPrice + codeDiscountData.originalPrice;
              currentPrice = currentPrice + ((parseInt(constituent.price)) * ((100 - codeDiscountAmountPercentage)/ 100) * parseInt(constituent.quantity));
            })
          } else {
            originalPrice = priceData.opx == "" ? parseInt(priceData.cpx) : parseInt(priceData.opx);
            currentPrice = parseInt(priceData.cpx);
            ({ currentPrice, originalPrice, discountAmount, discountMessage } = window.Branch.functions.returnDiscountCodeUpdates(currentPrice, originalPrice, discountAmount, discountMessage, product.handle));
          }
          // console.log('currentPrice', currentPrice);
          // console.log('originalPrice', originalPrice);
          // console.log('item', item);

          

          if(item && item[0] && item[0].querySelectorAll('.pre-order-swatch:not([data-initialized="true"])').length > 0){
            window.Branch.product.initPreOrderSwatch(discountMessage, discountAmount, item[0].querySelectorAll('.pre-order-swatch'), product.id, "Get 10% off, or 15% when you bundle during the Boxing Day Sale and get free shipping on all orders.");
          }

          let shouldBeSkipped = false;
          if(document.querySelector('#side-cart')){
            shouldBeSkipped = document.querySelector('#side-cart').getAttribute('data-stack-discount-code-with-bundle-discount') == 'false' && discountMessage != null
          } 

          window.Branch.functions.saleTagUpdate(variant.id, variantSwatchValue, originalPrice, currentPrice, product, 'product');

          let isSideCartBundleDiscount = isQuickView == true && document.querySelector('.quick-view .main-product__item') && document.querySelector('.quick-view .main-product__item').getAttribute('data-bundle-discount');
          if(isSideCartBundleDiscount && shouldBeSkipped == false){
            let addOnDiscountAmount = parseInt(document.querySelector('.quick-view .main-product__item').getAttribute('data-bundle-discount'));
            let discountMultiplier = ((100 - parseInt(addOnDiscountAmount))/100);
            originalPrice = priceData.opx == "" ? priceData.cpx : priceData.opx;
            currentPrice = priceData.cpx * discountMultiplier;
          }

          let isBundleBuilder = document.querySelector('body .main-product').getAttribute('data-bundle-builder-pop-up') == 'true' ? true : false;

          if(isBundleBuilder){
            let product_data = JSON.parse(document.querySelector('#bundle-product-data').innerHTML);
            let bundleDiscountAmount = parseInt(product_data[product.id]['bundle_discount'])
            let discount_multiplier = ((100 - parseInt(bundleDiscountAmount))/100);

            

            originalPrice = priceData.opx == "" ? priceData.cpx : priceData.opx;
            currentPrice = priceData.cpx * discount_multiplier;
        }
        if(originalPrice == currentPrice){
          originalPrice = null;
        }

          let priceContainers = item.find('.price-installments-wrapper .price');
          // console.log('here')
          if(priceContainers.length > 0){
            priceContainers.each(function() {
              let priceContainerParent = $(this).parent();
              let quantityRatio = priceContainerParent.closest('.main-product__item').attr('data-quantity-ratio') ? parseInt(priceContainerParent.closest('.main-product__item').attr('data-quantity-ratio')) : 1;
              let currentPriceRatio = currentPrice * quantityRatio;

              priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"])  [data-price="deal"]').html(Shopify.formatMoney(currentPriceRatio, Simplistic.formatMoney).split('.')[0].replace(' ',''));
              priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"])  [data-price="deal"]').attr('data-exact-price', currentPriceRatio);

              if(originalPrice != null && originalPrice){
                let originalPriceRatio = originalPrice * quantityRatio;
                var retailPrice = Shopify.formatMoney(originalPriceRatio, Simplistic.formatMoney).replace('.00', '').replace(' ','');
                var percentDiscount = Math.round( (((originalPriceRatio - currentPrice) * 100 ) / originalPriceRatio) );
                var moneyDiscount = Shopify.formatMoney((originalPriceRatio - currentPrice), Simplistic.formatMoney).replace('.00', '').replace(' ','');
                            
                if(discountMessage && discountMessage != null){
                  var modifiedMessage = discountMessage.replace('<p>',`<p>Save ${percentDiscount}% `)
                  priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="discount-code-off-percent"]').html(modifiedMessage);
                }
      
                priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="retail"]').html(retailPrice);
                priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) .retail').attr('data-visible', true);
                priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="off-percent"]').html(percentDiscount+'%');
                priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="off-amount"]').html(moneyDiscount);
      
              } else {
                priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="retail"]').html('');
                priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) .retail').attr('data-visible', false);
                priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="off-percent"]').html('');
                priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="off-amount"]').html('');
                priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="discount-code-off-percent"]').html('');
              }
            })
          }
        }
      };


    productJs.getProduct = function() {
      return product;
    };

	productJs.getCurrentVariantOption = function(option) {
      var value = '';
      $.each(product.options, function(key, val){
        if(val.toUpperCase()==option.toUpperCase()) {
          value = productJs.getCurrentVariant()[('option'+(key+1))];
        }
      });
      return value;
    };

    productJs.setVariant = function(variant){
      if(variant) {
        if(!isNaN(variant)) {
          variant = productJs.getVariantById(variant);
        }
        item.find('.single-option-selector').each(function(){
          var selector = this;
          var option = $(selector).data('option');
          $(selector).find('option').each(function(){
            if(this.value == variant[option]){
              $(selector).val(this.value).trigger('change');
              return;
            }
          });
        });
      }
    };
  
    var onVariantSelected = function() {
      return function(variant, selector) {
        var start = new Date().getTime();
        if(variant && variant.id) {
          let variantSwatchValue = false;



          if(isQuickView == false && typeof selected_main_product != undefined){
            selected_main_product['selected_variant'] = variant;
          }

          const bundleProduct = product.tags && product.tags.includes("bundle") ? true : false;
          if(bundleProduct){
            if(document.querySelector('body').classList.contains('template-page-bundles')){
              window.Branch.product.updateOldStyleBundle(variant.id, product.id, 'bundle-builder')
            }
            else {
              if(window.Branch.bundleScripts.updateBundleCartData){
                window.Branch.bundleScripts.updateBundleCartData(variant, product.id);
              }
            }
          }

          if(document.querySelector(`.addons_to_hide_when_variant_selected[data-product-id="${product.id}"]`)) {
            let addonsCurrentMainProductSelected = document.querySelector(`.addons-current-main-product-selected[data-product-id="${product.id}"]`);
            if(addonsCurrentMainProductSelected){
              variant.options.forEach((optionValue, index) => {
                addonsCurrentMainProductSelected.setAttribute(`data-option${index + 1}`, optionValue);
              })
              addonsCurrentMainProductSelected.setAttribute(`data-option-names`, product.options.map(optionName => Simplistic.handleize(optionName)).join(','));
            }

            let handlesToHide = [];
            let addonsToHideWhenVariantSelectedData = JSON.parse(document.querySelector(`.addons_to_hide_when_variant_selected[data-product-id="${product.id}"]`).innerText);
            
            addonsToHideWhenVariantSelectedData.forEach((dataLine) => {
              let index = product.options.findIndex(optionName => optionName.toLowerCase() === dataLine.option_name.toLowerCase());
              if(variant[`option${index + 1}`] && variant[`option${index + 1}`] == dataLine.option_value && dataLine.hide_on_pdp == true){
                handlesToHide.push(dataLine.addon_handle.toLowerCase());
              }
            })

            document.querySelectorAll(`.main-product__item .add-to-cart-form[data-product-id="${product.id}"] .addons .item[data-hidden="true"]`).forEach((addonElementToShow) => {
              addonElementToShow.style.display = '';
              addonElementToShow.setAttribute('data-hidden', 'false');
            });

            document.querySelectorAll(`.main-product__item .add-to-cart-form[data-product-id="${product.id}"] .addons .addon_Count`).forEach((addonCount) => {
              addonCount.innerHTML = `${addonCount.getAttribute('data-orig-length')} items`;
              addonCount.setAttribute('data-modified', 'false');
            })

            handlesToHide.forEach((handleToHide) => {
              let addonElementsToHide = document.querySelectorAll(`.main-product__item  .add-to-cart-form[data-product-id="${product.id}"] .addons__container .item[data-product-handle="${handleToHide}"]`);
              if(addonElementsToHide.length > 0){
                addonElementsToHide.forEach((addonElementToHide) => {
                  addonElementToHide.setAttribute('data-hidden', 'true');
                  addonElementToHide.style.display = 'none';
                  if(addonElementToHide.closest('.swiper').querySelector('.addon_Count')){
                    addonElementToHide.closest('.swiper').querySelector('.addon_Count').setAttribute('data-modified', 'true');
                  }
                })
              }
            })

            document.querySelectorAll(`.main-product__item .add-to-cart-form[data-product-id="${product.id}"] .addons .addon_Count[data-modified="true"]`).forEach((addonCount) => {
              addonCount.innerHTML = `${addonCount.getAttribute('data-orig-length') - handlesToHide.length} items`;
            })

            if(pdpaAddOnSwiperInstances && pdpaAddOnSwiperInstances.length > 0){
              pdpaAddOnSwiperInstances.forEach((pdpaAddOnSwiperInstance) => {
                pdpaAddOnSwiperInstance.update();
              })
            } 
          }

          let shippingSectionDataSection = document.querySelector(`#shipping-info-section-data[data-product-id="${product.id}"]`);
          if(shippingSectionDataSection){
            let shippingSectionData = JSON.parse(shippingSectionDataSection.innerText);
            let optionSelector = `option${shippingSectionData.option_index + 1}`;
            if(variant[`${optionSelector}`]) {
              let optionFromVariant = variant[`${optionSelector}`];
              let imageFromData = shippingSectionData.option_values[`${optionFromVariant}`];
              let shippingInfoImage = document.querySelector('.shipping-info-section__image');
              if(imageFromData && imageFromData != "") {
                shippingInfoImage.setAttribute('srcset', window.Branch.functions.returnSrcSet(imageFromData, 900))
              } else {
                shippingInfoImage.setAttribute('srcset', window.Branch.functions.returnSrcSet(shippingSectionData.backup_image, 900))
              }
            }
          }

          let epigraphInstances = document.querySelectorAll('epigraph-ar');
          if(epigraphInstances.length > 0){
            epigraphInstances.forEach((epigraphInstance) => {
              epigraphInstance.setAttribute('sku', variant.sku)
            })
          }

          if(document.querySelector(`.pre-order-swatch-data[data-product-id="${product.id}"]`)){
            let pdp_swatch_metafield_value = JSON.parse(document.querySelector(`.pre-order-swatch-data[data-product-id="${product.id}"]`).innerText);
            let variant_swatch_value = pdp_swatch_metafield_value['variant_level'][`${variant.id}`];         
            let preOrderSwatches = document.querySelectorAll(`.pre-order-swatch[data-product-id="${product.id}"]`);             

            // console.log('variant_swatch_value', variant_swatch_value)

            if(variant_swatch_value){
              variantSwatchValue = true;
              let variant_swatch_text_value = variant_swatch_value[0];
              let variant_swatch_tooltip_value = variant_swatch_value[1];
              preOrderSwatches.forEach((preOrderSwatch) => {
                if(preOrderSwatch.querySelector('span')){
                  preOrderSwatch.querySelector('span').innerHTML = `
                    <span class="pre-order-swatch__desktop">
                        ${variant_swatch_text_value}
                    </span>
                    <span class="pre-order-swatch__mobile">
                        ${variant_swatch_text_value}
                    </span>
                    <svg aria-hidden="true" tabindex="-1" role="presentation" class=" icon icon-tooltip" viewBox="0 0 18 17"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.26191 16.8867C14.0714 16.8867 17.9702 13.1436 17.9702 8.52635C17.9702 3.90907 14.0714 0.166016 9.26191 0.166016C4.45243 0.166016 0.553574 3.90907 0.553574 8.52635C0.553574 13.1436 4.45243 16.8867 9.26191 16.8867ZM8.01518 8.62759C7.85935 8.77719 7.78143 8.9664 7.78143 9.19521V10.1984C7.78143 10.4273 7.85935 10.6209 8.01518 10.7793C8.17101 10.9289 8.3681 11.0037 8.60643 11.0037C8.84476 11.0037 9.04185 10.9289 9.19768 10.7793C9.35351 10.6209 9.43143 10.4273 9.43143 10.1984V9.71003C9.43143 9.69243 9.43601 9.67923 9.44518 9.67043L9.50018 9.64403C9.89435 9.58242 10.2564 9.48122 10.5864 9.34042C10.9256 9.19081 11.2189 8.9972 11.4664 8.75959C11.7231 8.51318 11.9202 8.22277 12.0577 7.88836C12.1952 7.54514 12.2639 7.15353 12.2639 6.71351C12.2639 6.12388 12.1127 5.59586 11.8102 5.12944C11.5077 4.66302 11.0998 4.29341 10.5864 4.0206C10.0823 3.73899 9.51393 3.59818 8.88143 3.59818C8.37726 3.59818 7.9006 3.69059 7.45143 3.87539C7.01143 4.0514 6.62643 4.30221 6.29643 4.62782C6.10393 4.81263 6.01685 5.01504 6.03518 5.23505C6.05351 5.45506 6.17268 5.64426 6.39268 5.80267C6.60351 5.95228 6.80976 6.00068 7.01143 5.94788C7.22226 5.88627 7.40101 5.79387 7.54768 5.67067C7.73101 5.52106 7.93268 5.40226 8.15268 5.31425C8.38185 5.22625 8.62476 5.18225 8.88143 5.18225C9.21143 5.18225 9.50476 5.24825 9.76143 5.38025C10.0273 5.51226 10.2335 5.69267 10.3802 5.92148C10.536 6.15029 10.6139 6.4143 10.6139 6.71351C10.6139 7.11832 10.5223 7.44394 10.3389 7.69035C10.1648 7.93676 9.92643 8.11717 9.62393 8.23157C9.32143 8.33717 8.98226 8.38998 8.60643 8.38998C8.3681 8.38998 8.17101 8.46918 8.01518 8.62759ZM7.91893 13.1686C8.0656 13.3006 8.27185 13.3666 8.53768 13.3666H8.71643C8.98226 13.3666 9.18393 13.3006 9.32143 13.1686C9.4681 13.0278 9.54143 12.8298 9.54143 12.5745V12.3501C9.54143 12.0949 9.4681 11.9013 9.32143 11.7693C9.18393 11.6285 8.98226 11.5581 8.71643 11.5581H8.53768C8.27185 11.5581 8.0656 11.6285 7.91893 11.7693C7.78143 11.9013 7.71268 12.0949 7.71268 12.3501V12.5745C7.71268 12.8298 7.78143 13.0278 7.91893 13.1686Z" fill="white"></path>
                    </svg>`
                  preOrderSwatch.querySelector('span').setAttribute('data-tooltip', `${variant_swatch_tooltip_value}`) 
                  preOrderSwatch.setAttribute('data-display', 'true')
                }
              })
            } else if (preOrderSwatches[0] && preOrderSwatches[0].getAttribute('data-text-fallback') != "") {
              preOrderSwatches.forEach((preOrderSwatch) => {
                if(preOrderSwatch.querySelector('span')){
                  preOrderSwatch.querySelector('span').innerHTML = `
                    <span class="pre-order-swatch__desktop">
                        ${preOrderSwatch.getAttribute('data-text-fallback')}
                    </span>
                    <span class="pre-order-swatch__mobile">
                        ${preOrderSwatch.getAttribute('data-text-fallback-mobile')}
                    </span>
                    <svg aria-hidden="true" tabindex="-1" role="presentation" class=" icon icon-tooltip" viewBox="0 0 18 17"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.26191 16.8867C14.0714 16.8867 17.9702 13.1436 17.9702 8.52635C17.9702 3.90907 14.0714 0.166016 9.26191 0.166016C4.45243 0.166016 0.553574 3.90907 0.553574 8.52635C0.553574 13.1436 4.45243 16.8867 9.26191 16.8867ZM8.01518 8.62759C7.85935 8.77719 7.78143 8.9664 7.78143 9.19521V10.1984C7.78143 10.4273 7.85935 10.6209 8.01518 10.7793C8.17101 10.9289 8.3681 11.0037 8.60643 11.0037C8.84476 11.0037 9.04185 10.9289 9.19768 10.7793C9.35351 10.6209 9.43143 10.4273 9.43143 10.1984V9.71003C9.43143 9.69243 9.43601 9.67923 9.44518 9.67043L9.50018 9.64403C9.89435 9.58242 10.2564 9.48122 10.5864 9.34042C10.9256 9.19081 11.2189 8.9972 11.4664 8.75959C11.7231 8.51318 11.9202 8.22277 12.0577 7.88836C12.1952 7.54514 12.2639 7.15353 12.2639 6.71351C12.2639 6.12388 12.1127 5.59586 11.8102 5.12944C11.5077 4.66302 11.0998 4.29341 10.5864 4.0206C10.0823 3.73899 9.51393 3.59818 8.88143 3.59818C8.37726 3.59818 7.9006 3.69059 7.45143 3.87539C7.01143 4.0514 6.62643 4.30221 6.29643 4.62782C6.10393 4.81263 6.01685 5.01504 6.03518 5.23505C6.05351 5.45506 6.17268 5.64426 6.39268 5.80267C6.60351 5.95228 6.80976 6.00068 7.01143 5.94788C7.22226 5.88627 7.40101 5.79387 7.54768 5.67067C7.73101 5.52106 7.93268 5.40226 8.15268 5.31425C8.38185 5.22625 8.62476 5.18225 8.88143 5.18225C9.21143 5.18225 9.50476 5.24825 9.76143 5.38025C10.0273 5.51226 10.2335 5.69267 10.3802 5.92148C10.536 6.15029 10.6139 6.4143 10.6139 6.71351C10.6139 7.11832 10.5223 7.44394 10.3389 7.69035C10.1648 7.93676 9.92643 8.11717 9.62393 8.23157C9.32143 8.33717 8.98226 8.38998 8.60643 8.38998C8.3681 8.38998 8.17101 8.46918 8.01518 8.62759ZM7.91893 13.1686C8.0656 13.3006 8.27185 13.3666 8.53768 13.3666H8.71643C8.98226 13.3666 9.18393 13.3006 9.32143 13.1686C9.4681 13.0278 9.54143 12.8298 9.54143 12.5745V12.3501C9.54143 12.0949 9.4681 11.9013 9.32143 11.7693C9.18393 11.6285 8.98226 11.5581 8.71643 11.5581H8.53768C8.27185 11.5581 8.0656 11.6285 7.91893 11.7693C7.78143 11.9013 7.71268 12.0949 7.71268 12.3501V12.5745C7.71268 12.8298 7.78143 13.0278 7.91893 13.1686Z" fill="white"></path>
                    </svg>`;
                  preOrderSwatch.querySelector('span').setAttribute('data-tooltip', `${preOrderSwatch.getAttribute('data-tooltip-fallback')}`); 
                  preOrderSwatch.setAttribute('data-display', 'true')
                }
              })
            }
          }

          if(window.Branch && window.Branch.product && window.Branch.product.updateFeaturesSection){
            window.Branch.product.updateFeaturesSection(variant);
          }

          if(window.Branch && window.Branch.pdp && window.Branch.pdp.calloutChangeOnVariantSelect) {
            window.Branch.pdp.calloutChangeOnVariantSelect(variant.id, product.id);
          }

          

          let bundleTagPresent = product.tags && product.tags.includes('bundle')
          if(document.querySelector(`#variant_ship_date_metafield_values--${product.id}`)){
            let ship_date_metafield_value = JSON.parse(document.querySelector(`#variant_ship_date_metafield_values--${product.id}`).innerText)[`${variant.id}`];


            let ship_date_show_available = false;
            if(document.querySelector(`#variant_ship_date_show_available--${product.id}`)){
              ship_date_show_available = JSON.parse(document.querySelector(`#variant_ship_date_show_available--${product.id}`).innerText)[`${variant.id}`] == 'true';
            }
            let msbdMessage = document.querySelector(`#main-product-item-${product.id} .msbd-message[data-product-id="${product.id}"]`);
            let oosMessage = ship_date_metafield_value;
            let msbdInput = msbdMessage.querySelector(`#msbd-message__input--${product.id}`);

            if(!variant.available && !bundleTagPresent){
              msbdMessage.setAttribute('data-available', 'false');
                msbdMessage.querySelector(`.msbd-message__text--oos`).setAttribute('aria-hidden', 'false');
                msbdMessage.querySelector(`.msbd-message__text--available`).setAttribute('aria-hidden', 'true');  
              
              msbdInput.setAttribute('value', oosMessage);
              msbdInput.closest('.msbd-message').querySelector('.msbd-message__text--oos .msbd-message__oos-span').innerHTML = `${oosMessage} |`;
            } else {
              msbdMessage.setAttribute('data-available', 'true');
                msbdMessage.querySelector(`.msbd-message__text--oos`).setAttribute('aria-hidden', 'true');
                msbdMessage.querySelector(`.msbd-message__text--available`).setAttribute('aria-hidden', 'false');
                msbdInput.closest('.msbd-message').querySelector('.msbd-message__text--oos .msbd-message__oos-span').innerHTML = `${oosMessage} |`;

              msbdInput.setAttribute('value', ship_date_metafield_value)
            }
    
            msbdInput.setAttribute('data-variant-id', variant.id)
              msbdMessage.querySelector(`.msbd-message__text--available span.msbd-message__ship-date-span`).innerHTML = `${ship_date_show_available ? '<strong aria-hidden="true">Available | </strong>' : ''} ${ship_date_metafield_value}`;
          }
    
          

          let priceDataElement = document.querySelector(`.per-variant-pricing[data-product-handle="${product.handle}"]`);

          

            //Swatches code
            var form = item.find('form');

            
            for(var i=0,length=variant.options.length; i<length; i++) {
              var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
              var radioButtonSticky = stickyATC.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
              var radioButtonMobileSticky = mobileStickyAtc.find('.swatch-dropdown__sliding-option-selector-outer-container[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
              if(radioButton.length > 0) {
                radioButton.get(0).checked = true;

                if(radioButtonMobileSticky && radioButtonMobileSticky.get(0)){
                  radioButtonMobileSticky.get(0).checked = true;
                  let dropdowns = document.querySelectorAll('.mobile-sticky-atc__options .swatch-dropdown');
                  if(dropdowns.length > 0){
                    let dropdown = dropdowns[radioButtonMobileSticky[0].getAttribute('name').replace("option-mobile-sticky-", "")];
                    if(dropdown){
                      let label = dropdown.querySelector('label');
                      let value = radioButtonMobileSticky[0].getAttribute('value');
                      label.setAttribute('data-option-value', `${value.replace(" ", "-").toLowerCase()}`);
                      if(label.getAttribute('data-type') == "color"){
                        label.classList = `swatch-dropdown__bar-label swatch-dropdown__bar-label--selected  color-${value.replaceAll(" ", "-").replaceAll("/", "-").toLowerCase()}`;
                      } else {
                        let xsLabel = value.replaceAll(" inches", "″").replaceAll(" Inches", "″");
                        let xsLabelArray = value.replaceAll(" inches", " inches #").replaceAll(" Inches", " Inches #").split('#');
                        if(xsLabelArray.length > 1){
                          xsLabelArray.splice(1, 1)
                          xsLabel = xsLabelArray.join().replaceAll(" inches", "″").replaceAll(" Inches", "″").replaceAll(",", "").split('+')[0];
                        }
                        value = value.replace(/ ?inches/gi, "″");
                        
                        label.querySelector('span.swatch-dropdown__bar-label-option-value:not(.swatch-dropdown__bar-label-option-value--xs)').innerHTML = `${window.Branch.functions.stripVariantText(value, variantTextReplacementMetafield)}`;
                        label.querySelector('span.swatch-dropdown__bar-label-option-value--xs').innerHTML = `${window.Branch.functions.stripVariantText(xsLabel, variantTextReplacementMetafield)}`;
                        label.querySelector('span.visually-hidden').innerHTML = `${value} ${label.getAttribute('data-option-key')}`;

                      }
                    }
                  }
                }
                if(radioButtonSticky && radioButtonSticky.get(0)){
                  radioButtonSticky.get(0).checked = true;
                }
              }
            }

          // console.log('priceDataElement', priceDataElement)
          if(priceDataElement){
            productJs.updateDiscountCodePrice(variant, product, variantSwatchValue);
          }

          //Filter The images by variant
          filterImages(variant, true, variantSwatchValue);

          //Update the variant value to add to cart
          item.find('#product-'+product.id+'-variant').val(variant.id);
          let cartText = 'SELECT ADD ON';
          if(item.parents('.main-product[data-quick-view="true"]-bundle').length && document.querySelector(`.pdp-bundles-callout #bundle-addon-${product.id}`))
          {
            cartText = 'SELECT BUNDLE';
          }
          item.siblings('.addon-add-btn').find('.content-available span').html(`${cartText} +${Shopify.formatMoney(variant.price, Simplistic.formatMoney).replace('.00', '').replace(' ','')}`);
          if(!item.closest(".cart-addons")){     
            item.siblings('.addon-add-btn').find('.content-available span').attr('onclick', `window.Branch.addons.quickViewHandleATC(${variant.id}, ${item.siblings('.addon-add-btn').find('.content-available span').attr('data-product-id')})`);
          }
          item.siblings('.addon-add-btn').find('.content-available span').attr('data-bundle-variant-id', variant.id);

        } else {
          item.find('#product-'+product.id+'-variant').val("");
        }
        if(variant){
          updateButtons(variant);

          const pdpPrices = document.querySelectorAll('.price-installments-wrapper__pdp > div > div');
          if (pdpPrices.length > 0){
            pdpPrices.forEach((pdpPrice) => {
              pdpPrice.setAttribute('data-product-id', product.id)
            })
          }


          let mainProductSwatches = document.querySelectorAll('.main-product .swatch');
          if(mainProductSwatches.length > 0){
            window.Branch.product.updateVariantSwatchTitles(mainProductSwatches, variant, product.id, variantTextReplacementMetafield);
            window.Branch.product.updateColorSwatchTabsSelectedIndicator(mainProductSwatches, variant, product.id);
          }

          $(item).trigger("variantChange", [variant]);

          var end = new Date().getTime();
          var time = end - start;

          if(variantAlreadySelected == false){
            variantAlreadySelected = true;

            if(isQuickView == true){
              quickViewSwiper = window.Branch.productGallery.initGallery('quickView', item, filterImages, productJs.getCurrentVariant, initSwiper, initZoomSwiper, product);
            } else {
              const gallery = document.querySelector('.main-product__gallery-outer-container');

              let startX = 0;
              let startY = 0;
              let isSwiping = false;
              let interactionTarget = null;

              // Your custom logic
              function triggerYourFunction(eventType, interactionTarget) {
                if(isQuickView){
                  quickViewSwiper = window.Branch.productGallery.initGallery('quickView', item, filterImages, productJs.getCurrentVariant, initSwiper, initZoomSwiper, product);
                } else {
                  productGallerySwiper = window.Branch.productGallery.initGallery('main', item, filterImages, productJs.getCurrentVariant, initSwiper, initZoomSwiper, product);
                }
                if(window.innerWidth < 900 && eventType == 'swipe') {
                  interactionTarget.closest('.main-product__gallery-outer-container').querySelector('.swiper-pagination .swiper-pagination-bullet:nth-child(2)').dispatchEvent(new MouseEvent('click', { bubbles: true }));  
                } else {
                  setTimeout(() => {
                    interactionTarget.dispatchEvent(new MouseEvent('pointerdown', { bubbles: true }));
                    setTimeout(() => {
                      interactionTarget.dispatchEvent(new MouseEvent('pointerup', { bubbles: true }));
                    }, 1)
                  }, 1)
                }
              }

        

              function handleClick(e) {
                interactionTarget = e.target;

                gallery.removeEventListener('click', handleClick); 
                gallery.removeEventListener('mousedown', handleMouseDown);
                gallery.removeEventListener('mouseup', handleMouseUp);
                gallery.removeEventListener('touchstart', handleTouchStart);
                gallery.removeEventListener('touchend', handleTouchEnd);
                triggerYourFunction('click', interactionTarget);

              }
              gallery.addEventListener('click', handleClick);

              function handleTouchStart(e) {
                startX = e.touches[0].clientX;
                startY = e.touches[0].clientY;
                interactionTarget = e.target;
                isSwiping = true;
              }
              function handleTouchEnd(e) {
                if (!isSwiping) return;
                const endX = e.changedTouches[0].clientX;
                const endY = e.changedTouches[0].clientY;
                const diffX = endX - startX;
                const diffY = endY - startY;

                if (Math.abs(diffX) > 30 || Math.abs(diffY) > 30) {
                  gallery.removeEventListener('click', handleClick);
                  gallery.removeEventListener('mousedown', handleMouseDown);
                  gallery.removeEventListener('mouseup', handleMouseUp);
                  gallery.removeEventListener('touchstart', handleTouchStart);
                  gallery.removeEventListener('touchend', handleTouchEnd);

                  triggerYourFunction('swipe', interactionTarget);
                }
                isSwiping = false;
              }
              gallery.addEventListener('touchstart', handleTouchStart);
              gallery.addEventListener('touchend', handleTouchEnd);

              // --- Mouse swipe (one-time) ---
              function handleMouseDown(e) {
                startX = e.clientX;
                startY = e.clientY;
                interactionTarget = e.target;
                isSwiping = true;
              }
              function handleMouseUp(e) {
                if (!isSwiping) return;
                const endX = e.clientX;
                const endY = e.clientY;
                const diffX = endX - startX;
                const diffY = endY - startY;

                if (Math.abs(diffX) > 30 || Math.abs(diffY) > 30) {
                  gallery.removeEventListener('click', handleClick); // 🔁 Remove first
                  gallery.removeEventListener('mousedown', handleMouseDown);
                  gallery.removeEventListener('mouseup', handleMouseUp);
                  gallery.removeEventListener('touchstart', handleTouchStart);
                  gallery.removeEventListener('touchend', handleTouchEnd);

                  triggerYourFunction('swipe', interactionTarget);
                }
                isSwiping = false;
              }
              gallery.addEventListener('mousedown', handleMouseDown);
              gallery.addEventListener('mouseup', handleMouseUp);
            }
          }

          /* Update addon thumbnails */
          window.Branch.product.updateAddonThumbnailsToMatchSelectedVariant(product, variant)

          /* Update already-selected addons */
          window.Branch.product.updateSelectedAddons(product, variant)

          if(isQuickView == true){
            let parent = document.querySelector(`.main-product__item .swatches-container[data-product-id="${product.id}"]`)
            if(parent && parent.getAttribute('data-click-allowed') != 'true') {
              window.Branch.product.removeOverlayFromSwatches(product.id, '.main-product__item[data-quick-view="true"]')
            }
          }
        } else {
          if(isQuickView != true){
            let displayMobileThumbnailGallery = document.querySelector('#mobile-pdp-gallery-test') && document.querySelector('#mobile-pdp-gallery-test').getAttribute('data-test-active') == 'true';
            
            if(displayMobileThumbnailGallery){
              let currentCarouselId = parseInt(document.querySelector(`#main-product-item-${product.id} .main-product-gallery__mobile-carousel`).getAttribute('data-variant-id'));
              if(variant.id !== currentCarouselId){
                document.querySelector(`#main-product-item-${product.id} .main-product-gallery__mobile-carousel`).setAttribute('data-variant-id', variant.id)
                window.Branch.productGallery.mobileThumbnailGallery(product.id);
              }
            } else {
              window.Branch.productGallery.destroyExistingMobileThumbnailGallery(product.id)
            }
          }
        } 
      }

    };

    var filterImages = function(variant, notSwitchImg, variantSwatchValue) {
      if(variant) {
        
        //Main image in product page

        productJs.filterThumbs(product.options, variant, item.find('.main-product-gallery__inner-container'), product['allow_image_filtering_by_size']);
      }
    };
    
    var updateButtons = function(variant) {
      var status;
      if(product.available) {
        status = variant ? variant.status : 'available';
      } else {
        status = 'soldout';
      }

      let variantOptionSelector = product && variant ? document.querySelector(`.options[data-quick-view="true"] .select-variant#product-select-${product.id} option[value="${variant.id}"]`) : undefined;
      
      if(variantOptionSelector && variantOptionSelector.getAttribute('data-variant-avaiable') == "false"){
        status = 'soldout';
      }
      item.find('.buttons-wrapper .add-button, .buttons-wrapper .sold-out-button, .soldout-product-message').hide(); //Grid
      item.find('.content-available, .content-soldout').hide(); //Product page
      stickyATC.find('.content-available, .content-soldout').hide(); //Sticky
      mobileStickyAtc.find('.content-available, .content-soldout').hide(); //Mobile Sticky
      item.find('.quantity-box').removeClass('disabled'); //Product page
      if ($('.chat-with-sales-button-pdp').length) {
        switch(status) {
          case "available":
            item.find('.content-available').show(); //Product page
            item.closest('.main-product[data-quick-view="true"]').find('.addon-add-btn .content-soldout').hide(); //Grid
            item.closest('.main-product[data-quick-view="true"]').find('.addon-add-btn .content-available').show(); //Grid
            stickyATC.find('.content-available').show(); //Sticky
            mobileStickyAtc.find('.content-available').css("display", "flex") //Mobile Sticky
            item.find('.quantity-box').show(); //Product page
            break;
          case "soldout":

            item.find('.buttons-wrapper .add-button').prop("disabled",true);
            item.find('.soldout-product-message').show(); //Grid
            item.find('.quantity-box').hide(); //Product page
            if(item.attr('data-quick-view') == 'true'){
              item.find('.content-soldout').show(); //Product page
            }
            else if (item.parents('body.template-product-chat-with-sales').length == false) {
              item.find('.content-soldout').show(); //Product page
            }
            
            
            item.closest('.main-product[data-quick-view="true"]').find('.addon-add-btn .content-soldout').show(); //Grid
            item.closest('.main-product[data-quick-view="true"]').find('.addon-add-btn .content-available').hide(); //Grid
            stickyATC.find('.content-soldout').show(); //Sticky
            mobileStickyAtc.find('.content-soldout').css("display", "flex") //Mobile Sticky
            break;
        }
      }
      else {
        switch(status) {
          case "available":
            item.find('.buttons-wrapper .add-button').show(); //Grid
            item.find('.content-available').show(); //Product page
            item.closest('.main-product[data-quick-view="true"]').find('.addon-add-btn .content-soldout').hide(); //Grid
            item.closest('.main-product[data-quick-view="true"]').find('.addon-add-btn .content-available').show(); //Grid
            stickyATC.find('.content-available').show(); //Sticky
            mobileStickyAtc.find('.content-available').css("display", "flex"); //Mobile Sticky
            item.find('.quantity-box').removeClass('disabled'); //Product page
            break;
          case "soldout":
            item.find('.buttons-wrapper .sold-out-button').show(); //Grid
            item.find('.soldout-product-message').show(); //Grid
            item.find('.quantity-box').addClass('disabled'); //Product page
            item.find('.content-soldout').show(); //Product page
            item.closest('.main-product[data-quick-view="true"]').find('.addon-add-btn .content-soldout').show(); //Grid
            item.closest('.main-product[data-quick-view="true"]').find('.addon-add-btn .content-available').hide(); //Grid
            stickyATC.find('.content-soldout').show() //Sticky
            mobileStickyAtc.find('.content-soldout').css("display", "flex"); //Mobile Sticky
            break;
        }
      }
    };


  function showTooltip($trigger, options = {}) {
      const settings = $.extend({
          containerSelector: '.swatches-container',
          tooltipSelector: '.tooltip',
          modeAttr: 'tabs',
          displayClass: 'mobile-display',
          duration: 2000
      }, options);

      const $container = $trigger.closest(settings.containerSelector);
      const $tooltip = $trigger.find(settings.tooltipSelector);

      const rect = $tooltip[0].getBoundingClientRect();
      const $floatingTooltip = $tooltip.clone()
          .addClass(settings.displayClass)
          .addClass('tooltip--temp');

      $floatingTooltip.css({
          position: 'fixed',
          top: rect.top + 'px',
          left: rect.left + 'px',
          width: rect.width + 'px',
          opacity: 1,
          visibility: 'visible',
          bottom: 'auto',
          'pointer-events': 'none',
          'z-index': 9999,
          'transform': 'translateY(calc(-100% + 5px))'
      });

      $('#page').append($floatingTooltip);

      const $outer = $tooltip.closest('.swatch-tab-inner');

      const scrollTop = $outer.scrollTop();  // save
      const scrollLeft = $outer.scrollLeft();

      $outer.css({
          'overflow': 'hidden',
          'scroll-behavior': 'auto'
      });

      const cleanup = () => {
          $floatingTooltip.remove();
          $outer.css('overflow', ''); 
          $outer.scrollTop(scrollTop); 
          $outer.scrollLeft(scrollLeft);
          $trigger.off('mouseleave.tooltipTemp');
      };

      const removeTimeout = setTimeout(cleanup, settings.duration);

      $trigger.on('mouseleave.tooltipTemp', () => {
          clearTimeout(removeTimeout);
          cleanup();
      });
    }
   

    var updateOptionsInSelector = function(selectorIndex) {
      switch (selectorIndex) {
          case 0:
              var key = "root";
              var selector = item.find(".single-option-selector:eq(0)");
              break;
          case 1:
              var key = item.find(".single-option-selector:eq(0)").val();
              var selector = item.find(".single-option-selector:eq(1)");
              break;
          case 2:
              var key = item.find(".single-option-selector:eq(0)").val();
              key += " / " + item.find(".single-option-selector:eq(1)").val();
              var selector = item.find(".single-option-selector:eq(2)")
      }
      var initialValue = selector.val();
      selector.empty();
      var options = optionsMapAll[key];
      if (options) {
          for (var i = 0; i < options.length; i++) {
              var option = options[i];
              var newOption = jQuery("<option></option>").val(option).html(option);
              selector.append(newOption)
          }
      }


      var availableOptions = optionsMap[key];
      var existingOptions = optionsMapAll[key];

      item.find('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
          if (jQuery.inArray($(this).attr("data-value"), existingOptions) !== -1) {
            $(this).off();
              if (jQuery.inArray($(this).attr("data-value"), availableOptions) !== -1) {
                  $(this).removeClass("soldout").find(":radio").removeAttr("checked");
                  $(this).find('.tooltip').text(`${$(this).attr("data-value")}`);
              } else {
                  if (item.parents('.template-product-chat-with-sales').length == false) {
                    $(this).addClass("soldout").find(":radio").removeAttr("checked");
                    $(this).find('.tooltip').text('Out of stock');

                    if(window.Branch.functions.isTouchDevice()){
                    $(this).on('click', function(){
                      showTooltip($(this));
                    })
                  } else {
                    $(this).on('mouseenter', function(){
                      showTooltip($(this));
                    })
                  }
                  }
                
              }
              $(this).find('input').prop('disabled', false);
              $(this).removeClass("option-not-available");
          } else {
              $(this).find('input').prop('disabled', true)
              $(this).find('.tooltip').text('Not available')
              $(this).addClass("option-not-available");
              if(window.Branch.functions.isTouchDevice()){
                $(this).on('click', function(){
                  showTooltip($(this));
                });
              } else {
                $(this).on('mouseenter', function(){
                  showTooltip($(this));
                })
              }
          }
      });

      if(isQuickView == false){
      stickyATC.find('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
        if (jQuery.inArray($(this).attr("data-value"), existingOptions) !== -1) {
          $(this).off();
            if (jQuery.inArray($(this).attr("data-value"), availableOptions) !== -1) {
                $(this).removeClass("soldout").find(":radio").removeAttr("checked");
                $(this).find('.tooltip').text(`${$(this).attr("data-value")}`);
            } else {
                if (item.parents('.template-product-chat-with-sales').length == false) {
                  $(this).addClass("soldout").find(":radio").removeAttr("checked");
                  $(this).find('.tooltip').text('Out of stock');
                  if(window.Branch.functions.isTouchDevice()){
                    $(this).on('click', function(){
                      showTooltip($(this));
                    })
                  } else {
                    $(this).on('mouseenter', function(){
                      showTooltip($(this));
                    })
                  }
                 }


            }
            $(this).find('input').prop('disabled', false);
            $(this).removeClass("option-not-available");
        } else {
            $(this).find('input').prop('disabled', true)
            $(this).find('.tooltip').text('Not available')
            $(this).addClass("option-not-available");
            if(window.Branch.functions.isTouchDevice()){
              $(this).on('click', function(){
                showTooltip($(this));
              });
            } else {
              $(this).on('mouseenter', function(){
                showTooltip($(this));
              })
            }
        }
      });
      }

      /* new sticky atc */
      if(isQuickView == false){
      mobileStickyAtc.find('.swatch-dropdown__sliding-option-selector-outer-container[data-option-index="' + selectorIndex + '"] .swatch-dropdown__sliding-option-selector-element').each(function() {
        let label = document.querySelectorAll('.swatch-dropdown')[selectorIndex].querySelector('.swatch-dropdown__bar-label');
        if (jQuery.inArray($(this).attr("data-value"), existingOptions) !== -1) {
          $(this).off();
            if (jQuery.inArray($(this).attr("data-value"), availableOptions) !== -1) {
                $(this).removeClass("soldout").find(":radio").removeAttr("checked");
              
                label.setAttribute('data-availability', 'available');
            } else {
              if (item.parents('.template-product-chat-with-sales').length == false) {
                $(this).addClass("soldout").find(":radio").removeAttr("checked");  
                label.setAttribute('data-availability', 'soldout');
              }
            }
            $(this).find('input').prop('disabled', false);
            $(this).removeClass("option-not-available");
            label.setAttribute('data-availability', 'available');
        } else {
            $(this).find('input').prop('disabled', true)
            $(this).addClass("option-not-available");
            label.setAttribute('data-availability', 'option-not-available');
        }
      });
      }
      /* end new sticky atc */

      item.find('.swatches-container__colors_selected-info-swatch').attr('data-unavailable', 'false');
      item.find('.swatch-element.option-not-available, .swatch-element.soldout').each(function () {
        const $swatchElement = $(this);
        const $tabContainer = $swatchElement.closest('.swatches-container__tab-outer-container');

        const colorClass = $swatchElement.find('label[role="button"]').attr('class')?.match(/color-[^\s]+/);

        if (colorClass) {
          const selector = `.swatches-container__colors_selected-info-swatch.${colorClass[0]}`;

          $tabContainer.find(selector).attr('data-unavailable', 'true');

          const overlayClass = $swatchElement.find('label[role="button"]').find('.swatch__not-available-overlay').hasClass('dark') ? 'dark' : 'light';

          if (overlayClass) {
            $tabContainer.find(selector).attr('data-color', overlayClass);
          }
        }
      });

      if (jQuery.inArray(initialValue, availableOptions) !== -1) {
          selector.val(initialValue)
      }
      // selector.trigger("change")
  };
  var linkOptionSelectors = function(product) {
      for (var i = 0; i < product.variants.length; i++) {
          var variant = product.variants[i];
          optionsMapAll.root = optionsMapAll.root || [];
          optionsMapAll.root.push(variant.option1);
          optionsMapAll.root = Shopify.uniq(optionsMapAll.root);
          if (product.options.length > 1) {
              var key = variant.option1;
              optionsMapAll[key] = optionsMapAll[key] || [];
              optionsMapAll[key].push(variant.option2);
              optionsMapAll[key] = Shopify.uniq(optionsMapAll[key])
          }
          if (product.options.length === 3) {
              var key = variant.option1 + " / " + variant.option2;
              optionsMapAll[key] = optionsMapAll[key] || [];
              optionsMapAll[key].push(variant.option3);
              optionsMapAll[key] = Shopify.uniq(optionsMapAll[key])
          }
          if (variant.available) {
              optionsMap.root = optionsMap.root || [];
              optionsMap.root.push(variant.option1);
              optionsMap.root = Shopify.uniq(optionsMap.root);
              if (product.options.length > 1) {
                  var key = variant.option1;
                  optionsMap[key] = optionsMap[key] || [];
                  optionsMap[key].push(variant.option2);
                  optionsMap[key] = Shopify.uniq(optionsMap[key])
              }
              if (product.options.length === 3) {
                  var key = variant.option1 + " / " + variant.option2;
                  optionsMap[key] = optionsMap[key] || [];
                  optionsMap[key].push(variant.option3);
                  optionsMap[key] = Shopify.uniq(optionsMap[key])
              }
          }
      }
      updateOptionsInSelector(0);
      if (product.options.length > 1) updateOptionsInSelector(1);
      if (product.options.length === 3) updateOptionsInSelector(2);
      item.find(".single-option-selector:eq(0)").change(function() {
          updateOptionsInSelector(1);
          if (product.options.length === 3) updateOptionsInSelector(2);
          return !0
      });
      item.find(".single-option-selector:eq(1)").change(function() {
          if (product.options.length === 3) updateOptionsInSelector(2);
          return !0
      })
  }

    return init();    
};
